import alertsx from '@components/_shared/Alerts/AlertsSx';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@mui/material';
import { Alert, HistoricalAlert } from '@src/types/Alerts';
import { ConfigState } from '@store/reducers/configData';
import { ServiceState } from '@store/reducers/serviceData';
import storeConnector from '@store/storeConnector';
import { tsDueTimeMode } from '@utils/index_ts';

function AcknowledgedInfoCell({
  alertEntity,
  timeMode,
  siteMeta,
}: {
  alertEntity: Alert;
  timeMode: ServiceState['timeMode'];
  siteMeta: ConfigState['siteMeta'];
}) {
  const { ackedBy, ackedNote, ackedTs, isAcked } =
    alertEntity as HistoricalAlert;

  if (!isAcked) {
    return null;
  }

  const title = (
    <div>
      {ackedBy && <div>{ackedBy}</div>}
      {ackedNote && <div>{ackedNote}</div>}
      {ackedTs && (
        <div>
          {tsDueTimeMode({
            timeMode,
            lat: siteMeta.GPSLat,
            long: siteMeta.GPSLong,
            ts: ackedTs,
          }).toString()}
        </div>
      )}
    </div>
  );

  return (
    <Tooltip title={title} placement='left'>
      <Box sx={alertsx.alertCenterAlignBox}>
        <FontAwesomeIcon icon={faCheck} size='lg' />
      </Box>
    </Tooltip>
  );
}

export default storeConnector(AcknowledgedInfoCell, {
  service: ['timeMode'],
  config: ['siteMeta'],
});
